import BorderRadius from '@omni/kit/theming/BorderRadius';

export const ARTWORK_BORDER_RADIUS = BorderRadius.m;
